import HomePage from './Components/HomePage/HomePage';
function App() {
  return (
    <div>
      <HomePage />
    </div>
  );
}

export default App;
